import MorphedSVG from './MorphedSVG'

const video = {

    ui: {},

    players: [],

    init: function() {
        this.bindUI();
        this.bindPlaypause();
    },

    bindUI: function() {
        this.ui.$video = document.querySelectorAll('.js-video');
        this.ui.$video_playpause = document.querySelectorAll('.js-video-playpause');
    },

    bindPlaypause: function() {
        this.ui.$video_playpause.forEach(playpauseButton => {
            let svg = playpauseButton.querySelector('svg');
            let path = svg.querySelector('path');
            let from_path = path.getAttribute('d');
            let to_path = path.getAttribute('data-path-to');

            let animButtonSvg = new MorphedSVG(
                svg, from_path, to_path
            );

            playpauseButton.addEventListener('click', function(e){
                this.playpause_Video(e);
                animButtonSvg.toggle();
            }.bind(this));
        });
    },

    playpause_Video: function(e) {
        let button = e.currentTarget;
        let video = e.currentTarget.parentNode.querySelector('.js-video');

        if (button.classList.contains('is-playing')) {
            button.classList.remove('is-playing');
            button.classList.add('is-paused');
            video.pause();
        } else {
            button.classList.add('is-playing');
            button.classList.remove('is-paused');
            video.play();
        }
    },
};

export default video;
